import React from "react";
import { Link } from "react-router-dom";
import useSEO from "@/lib/useSEO";

export default function NotFound() {
  useSEO({
    title: "Page Not Found — LexWorkspace",
    description: "That page isn't on the schedule. Try the homepage, the stenography landing page, or the AI legal drafting landing page.",
    noindex: true,
  });
  return (
    <section
      data-testid="not-found-page"
      className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-32 lg:py-44"
    >
      <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-6">
        Error 404
      </p>
      <h1 className="font-serif-display text-5xl sm:text-7xl leading-none mb-6">
        That page isn&apos;t on the schedule.
      </h1>
      <p className="text-gray-600 max-w-xl text-lg mb-12">
        Try the homepage, the stenography landing page, or the AI legal
        drafting landing page.
      </p>
      <div className="flex flex-wrap gap-3">
        <Link to="/" className="btn-sharp bg-black text-white" data-testid="nf-home">
          Home
        </Link>
        <Link
          to="/stenopacemaster"
          className="btn-sharp bg-[#1E3A8A] text-white"
          data-testid="nf-steno"
        >
          Stenography
        </Link>
        <Link
          to="/draftmaster"
          className="btn-sharp bg-[#065F46] text-white"
          data-testid="nf-draft"
        >
          Legal AI
        </Link>
      </div>
    </section>
  );
}
